
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Relocation Services',
      description: 'Domestic & international moves with complete planning and support. Our experienced team ensures your belongings are handled with care at every step.',
      features: ['Domestic Moving', 'International Relocations', 'Complete Planning', 'Professional Support']
    },
    {
      icon: 'ri-tools-line',
      title: 'Handyman Services',
      description: 'Furniture assembly & disassembly, repairs and installations. We handle all your handyman needs to get your space perfectly set up.',
      features: ['Furniture Assembly', 'Furniture Disassembly', 'General Repairs', 'Professional Installations']
    },
    {
      icon: 'ri-image-line',
      title: 'Picture & Mirror Hanging',
      description: 'Professional hanging solutions for mirrors and pictures. Our team ensures precise placement and secure installation. Curtain installation also available on request.',
      features: ['Picture Hanging', 'Mirror Mounting', 'Curtain Installation (optional)', 'Secure & Precise Placement']
    },
    {
      icon: 'ri-guide-line',
      title: 'Guide – Transparent Move Consultancy',
      description: 'We protect clients from hidden costs, doubled invoices, overpriced crates and handyman bills. Independent consultancy even if we don\'t execute the move.',
      features: ['Transparent Pricing', 'Protection from Hidden Costs', 'Independent Consultancy', '10+ Years Experience']
    },
    {
      icon: 'ri-palette-line',
      title: 'Recently Appointed: Fine Art Division',
      description: 'Professional art handling and installation with museum-grade care. Specialized protection and secure installation for valuable pieces.',
      features: ['Professional Art Handling', 'Museum-Grade Care', 'Secure Installation', 'Specialized Protection']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Premium Service Package',
      description: 'Complete protection and peace of mind with our fully licensed and insured service. Expert professional teams with modern fleet and dedicated support throughout your entire journey.',
      features: ['Fully Licensed & Insured', 'Expert Professional Teams', 'Modern Fleet', 'Dedicated Support']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            We provide a complete range of relocation and handyman solutions tailored to your needs
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
